import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import SessionReporting from "../../components/SessionReporting";
import Loader from "../../components/Loaders/Loader";
import "./SessionReportingPage.css";

const SessionReportingPage = () => {
  const { vTrackLoader } = useSelector(({ APP_STATE }) => APP_STATE);

  useEffect(() => {
    document.title = "Session Reporting - Veersa Portal";
  }, []);

  return (
    <>
      {vTrackLoader && <Loader />}
      <div className="session-reporting-page">
        <SessionReporting />
      </div>
    </>
  );
};

export default SessionReportingPage;
